/* GOWin audit bootstrap — preserves existing behavior and fixes full drawer scroll. */
(()=>{
  const hostScript=document.currentScript||[...document.scripts].find(script=>script.src.includes('gowin-audit-improvements.js'));
  const hostSrc=hostScript?.src||'';
  const coreSrc=hostSrc.replace(/gowin-audit-improvements\.js(?=\?|$)/,'gowin-audit-improvements-core.js');
  const STYLE_ID='gowin-drawer-unified-scroll';

  const applyScrollFix=()=>{
    let style=document.getElementById(STYLE_ID);

    if(!style){
      style=document.createElement('style');
      style.id=STYLE_ID;
      style.textContent=`
        html body cart-drawer.drawer .cart-drawer .drawer__inner{
          display:flex!important;
          flex-direction:column!important;
          height:100vh!important;
          height:100dvh!important;
          min-height:0!important;
          overflow-x:hidden!important;
          overflow-y:auto!important;
          overscroll-behavior-x:none!important;
          overscroll-behavior-y:contain!important;
          -webkit-overflow-scrolling:touch!important;
          scroll-padding-bottom:max(2.4rem,env(safe-area-inset-bottom))!important;
          touch-action:pan-y!important;
        }

        html body cart-drawer.drawer .cart-drawer .drawer__header{
          position:sticky!important;
          top:0!important;
          z-index:20!important;
          flex:0 0 auto!important;
          width:100%!important;
          background:rgb(var(--color-background))!important;
        }

        html body cart-drawer.drawer .cart-drawer cart-drawer-items{
          display:block!important;
          flex:0 0 auto!important;
          width:100%!important;
          height:auto!important;
          min-height:0!important;
          max-height:none!important;
          overflow:visible!important;
          overscroll-behavior:auto!important;
          -webkit-overflow-scrolling:auto!important;
          touch-action:auto!important;
        }

        html body cart-drawer.drawer .cart-drawer .cart-drawer__form,
        html body cart-drawer.drawer .cart-drawer .drawer__contents,
        html body cart-drawer.drawer .cart-drawer .drawer__cart-items-wrapper{
          display:block!important;
          flex:0 0 auto!important;
          width:100%!important;
          height:auto!important;
          min-height:0!important;
          max-height:none!important;
          overflow:visible!important;
        }

        html body cart-drawer.drawer .cart-drawer .drawer__footer{
          position:relative!important;
          inset:auto!important;
          display:block!important;
          flex:0 0 auto!important;
          width:100%!important;
          height:auto!important;
          min-height:0!important;
          max-height:none!important;
          overflow:visible!important;
          padding-bottom:max(2.4rem,env(safe-area-inset-bottom))!important;
        }

        html body cart-drawer.drawer .cart-drawer [data-gowin-drawer-suggestions]{
          overflow-x:auto!important;
          overflow-y:hidden!important;
          overscroll-behavior-x:contain!important;
          overscroll-behavior-y:auto!important;
          touch-action:pan-x pan-y!important;
        }

        html body cart-drawer.drawer .cart-drawer #CartDrawer-Checkout{
          margin-bottom:max(.4rem,env(safe-area-inset-bottom))!important;
        }
      `;
      (document.head||document.documentElement).appendChild(style);
    }

    document.querySelectorAll('cart-drawer .drawer__inner').forEach(inner=>{
      inner.setAttribute('data-gowin-unified-scroll','true');
    });
  };

  const loadCore=()=>{
    const existing=[...document.scripts].find(script=>script.src.includes('gowin-audit-improvements-core.js'));

    if(existing){
      if(existing.dataset.gowinLoaded==='true'){
        applyScrollFix();
      }else{
        existing.addEventListener('load',applyScrollFix,{once:true});
      }
      return;
    }

    if(!coreSrc||coreSrc===hostSrc){
      applyScrollFix();
      return;
    }

    const core=document.createElement('script');
    core.src=coreSrc;
    core.async=false;
    core.dataset.gowinAuditCore='true';
    core.addEventListener('load',()=>{
      core.dataset.gowinLoaded='true';
      applyScrollFix();
      requestAnimationFrame(applyScrollFix);
    },{once:true});
    core.addEventListener('error',applyScrollFix,{once:true});

    if(hostScript?.parentNode){
      hostScript.parentNode.insertBefore(core,hostScript.nextSibling);
    }else{
      (document.head||document.documentElement).appendChild(core);
    }
  };

  const resetOnOpen=new MutationObserver(records=>{
    records.forEach(record=>{
      const drawer=record.target;
      if(!(drawer instanceof Element)||!drawer.matches('cart-drawer'))return;

      const active=drawer.classList.contains('active');
      const wasActive=drawer.dataset.gowinWasActive==='true';

      if(active&&!wasActive){
        requestAnimationFrame(()=>{
          const inner=drawer.querySelector('.drawer__inner');
          if(inner)inner.scrollTop=0;
        });
      }

      drawer.dataset.gowinWasActive=String(active);
    });
  });

  const observeDrawers=()=>{
    document.querySelectorAll('cart-drawer').forEach(drawer=>{
      if(drawer.dataset.gowinScrollObserved==='true')return;
      drawer.dataset.gowinScrollObserved='true';
      drawer.dataset.gowinWasActive=String(drawer.classList.contains('active'));
      resetOnOpen.observe(drawer,{attributes:true,attributeFilter:['class']});
    });
  };

  loadCore();
  applyScrollFix();

  const init=()=>{
    applyScrollFix();
    observeDrawers();
  };

  document.readyState==='loading'
    ?document.addEventListener('DOMContentLoaded',init,{once:true})
    :init();

  document.addEventListener('cart:updated',()=>requestAnimationFrame(init));
  document.addEventListener('shopify:section:load',()=>requestAnimationFrame(init));
  window.addEventListener('pageshow',init);
})();

/* Drawer suggestion compare price + discount badge — keeps card dimensions unchanged. */
(()=>{
  if(window.GowinDrawerDiscountPricing)return;
  window.GowinDrawerDiscountPricing=true;

  const STYLE_ID='gowin-drawer-discount-pricing';
  const CARD_SELECTOR='.gowin-drawer-shipping__card';
  const SHIPPING_SELECTOR='cart-drawer [data-gowin-drawer-shipping]';
  const productCache=new Map();
  let frame=0;

  const ensureStyles=()=>{
    if(document.getElementById(STYLE_ID))return;

    const style=document.createElement('style');
    style.id=STYLE_ID;
    style.textContent=`
      html body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__price-row{
        grid-column:1!important;
        display:flex!important;
        align-items:baseline!important;
        gap:.35rem!important;
        width:100%!important;
        min-width:0!important;
        max-width:100%!important;
        height:auto!important;
        min-height:0!important;
        margin:0!important;
        overflow:hidden!important;
        white-space:nowrap!important;
        line-height:1.1!important;
      }

      html body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__price-row .gowin-drawer-shipping__price{
        flex:0 0 auto!important;
        display:inline!important;
        width:auto!important;
        min-width:0!important;
        max-width:none!important;
        margin:0!important;
        line-height:1.1!important;
        white-space:nowrap!important;
      }

      html body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__compare-price{
        flex:0 1 auto!important;
        min-width:0!important;
        max-width:8rem!important;
        margin:0!important;
        overflow:hidden!important;
        color:#8b93a3!important;
        font-size:.92rem!important;
        font-weight:600!important;
        line-height:1.1!important;
        text-overflow:ellipsis!important;
        white-space:nowrap!important;
        text-decoration-line:line-through!important;
        text-decoration-thickness:.1rem!important;
      }

      html body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__discount{
        flex:0 0 auto!important;
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        width:auto!important;
        min-width:0!important;
        min-height:1.65rem!important;
        margin:0!important;
        padding:.12rem .38rem!important;
        border-radius:999px!important;
        color:#3f7f1d!important;
        background:#edf6e8!important;
        font-size:.78rem!important;
        font-weight:850!important;
        line-height:1!important;
        letter-spacing:0!important;
        white-space:nowrap!important;
      }

      @media screen and (max-width:389px){
        html body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__price-row{
          gap:.25rem!important;
        }

        html body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__compare-price{
          max-width:6.7rem!important;
          font-size:.82rem!important;
        }

        html body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__discount{
          min-height:1.55rem!important;
          padding:.1rem .3rem!important;
          font-size:.72rem!important;
        }
      }
    `;

    (document.head||document.documentElement).appendChild(style);
  };

  const formatCRC=cents=>{
    const colones=Math.round(Number(cents||0)/100);
    return `₡ ${String(colones).replace(/\B(?=(\d{3})+(?!\d))/g,'.')}`;
  };

  const productJSONURL=link=>{
    try{
      const url=new URL(link.href,window.location.origin);
      url.search='';
      url.hash='';
      url.pathname=`${url.pathname.replace(/\.js$/,'').replace(/\/$/,'')}.js`;
      return url.toString();
    }catch(error){
      return '';
    }
  };

  const getProduct=url=>{
    if(!url)return Promise.resolve(null);

    if(!productCache.has(url)){
      productCache.set(
        url,
        fetch(url,{
          headers:{
            Accept:'application/json',
            'X-Requested-With':'XMLHttpRequest'
          },
          cache:'force-cache'
        })
          .then(response=>response.ok?response.json():null)
          .catch(()=>null)
      );
    }

    return productCache.get(url);
  };

  const clearPricing=(card)=>{
    const row=card.querySelector('.gowin-drawer-shipping__price-row');
    if(!row)return;

    const price=row.querySelector('.gowin-drawer-shipping__price');
    row.querySelectorAll('.gowin-drawer-shipping__compare-price,.gowin-drawer-shipping__discount').forEach(node=>node.remove());

    if(price&&row.parentNode){
      row.parentNode.insertBefore(price,row);
      row.remove();
    }
  };

  const renderDiscount=(card,variant)=>{
    const current=Number(variant?.price||0);
    const compare=Number(variant?.compare_at_price||0);

    if(current<=0||compare<=current){
      clearPricing(card);
      card.dataset.gowinDiscountState='none';
      return;
    }

    const price=card.querySelector('.gowin-drawer-shipping__price');
    if(!price){
      card.dataset.gowinDiscountState='none';
      return;
    }

    let row=card.querySelector('.gowin-drawer-shipping__price-row');

    if(!row){
      row=document.createElement('span');
      row.className='gowin-drawer-shipping__price-row';
      price.parentNode.insertBefore(row,price);
      row.appendChild(price);
    }

    row.querySelectorAll('.gowin-drawer-shipping__compare-price,.gowin-drawer-shipping__discount').forEach(node=>node.remove());

    const comparePrice=document.createElement('s');
    comparePrice.className='gowin-drawer-shipping__compare-price';
    comparePrice.textContent=formatCRC(compare);
    comparePrice.setAttribute('aria-label',`Precio anterior ${formatCRC(compare)}`);

    const percent=Math.max(1,Math.round(((compare-current)/compare)*100));
    const badge=document.createElement('span');
    badge.className='gowin-drawer-shipping__discount';
    badge.textContent=`−${percent}%`;
    badge.setAttribute('aria-label',`${percent}% de descuento`);

    row.append(comparePrice,badge);
    card.dataset.gowinDiscountState='done';
  };

  const enrichCard=async card=>{
    if(!card||card.dataset.gowinDiscountState)return;

    const button=card.querySelector('[data-gowin-drawer-add]');
    const link=card.querySelector('.gowin-drawer-shipping__product-title');
    const variantId=button?.dataset.gowinDrawerAdd;

    if(!variantId||!link){
      card.dataset.gowinDiscountState='none';
      return;
    }

    card.dataset.gowinDiscountState='loading';

    const product=await getProduct(productJSONURL(link));
    const variant=product?.variants?.find(item=>String(item.id)===String(variantId));

    if(!variant){
      card.dataset.gowinDiscountState='none';
      return;
    }

    renderDiscount(card,variant);
  };

  const init=(root=document)=>{
    ensureStyles();

    const cards=[];
    const addCard=card=>{
      if(!card||!card.closest(SHIPPING_SELECTOR)||cards.includes(card))return;
      cards.push(card);
    };

    if(root instanceof Element&&root.matches(CARD_SELECTOR))addCard(root);
    root.querySelectorAll?.(CARD_SELECTOR).forEach(addCard);
    cards.forEach(enrichCard);
  };

  const scheduleInit=()=>{
    cancelAnimationFrame(frame);
    frame=requestAnimationFrame(()=>init(document));
  };

  document.readyState==='loading'
    ?document.addEventListener('DOMContentLoaded',()=>init(document),{once:true})
    :init(document);

  document.addEventListener('cart:updated',scheduleInit);
  document.addEventListener('shopify:section:load',scheduleInit);
  window.addEventListener('pageshow',scheduleInit);

  const observer=new MutationObserver(records=>{
    for(const record of records){
      if([...record.addedNodes].some(node=>node.nodeType===1)){
        scheduleInit();
        break;
      }
    }
  });

  if(document.documentElement){
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }
})();
